<template>
    <div>
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('CheckedStatement.CheckedStatementQuery')}}</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="supplier">
                                <p>{{$t('OrderInfo_Vue.VendorId')}}：</p>
                                <input type="text" v-if="isDisableVendorId" :disabled="isDisableVendorId" v-model="statementQueryParam.vendorId">                            
                                <Select2 style="width: 500px;" v-if="!isDisableVendorId" v-model="statementQueryParam.vendorIdList" :options="memberListFilter()" :settings="{ 'multiple': 'true' }" />
                            </div>                            
                            <div class="btn_group">
                                <button type="button" class="btn btn-edit mr-2" @click="statementSearchEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-blue mr-2" @click="statementExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            statementQueryParam :{
                vendorId: '',
                vendorIdList:[],
                erdatBegin: null,
                erdatEnd: null
            },
        }
    },
    props : {
    },
    methods: {
        checkSearchParam(){ //檢核條件
           const {erdatBegin,erdatEnd} =this.statementQueryParam;
           let errMsg = '';
           if(erdatBegin && erdatEnd){
               if(erdatBegin>erdatEnd){
                 errMsg='對帳日期區間錯誤，起始日不得大於終止日!';
               }
           }         
           if(errMsg){
                this.$alert(errMsg , '警告',{type: 'warning'});
                return false;
           }
           return true;
        },
        statementSearchEvent (){ //搜尋
            if(!this.checkSearchParam()){
                return;
            }
            this.$emit('statementSearch', this.statementQueryParam);
        },
        statementExportEvent (){ //匯出
            const url = `${this.$apiUrl_Order}/PrepareSearchStatementExport`;
            this.axios.post(url, this.statementQueryParam).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Order}/SearchStatementExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('statementExporttExcel',urlExcel);
            })
        }
    },
    computed: {
        ...mapGetters(["lang"]),
        isDisableVendorId (){
            if(this.isMember){
                return true;
            }
            return false;
        }
    },
	mounted() {
        let userInfo = this.$userInfo ;
        if(this.isMember){            
            this.statementQueryParam.vendorId = userInfo.vendorId;            
        }else{
            this.initMemberList();
        }
        //--預設查詢
        this.statementSearchEvent ();
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .supplier, .date_range, .number_range, .watch, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

.btn-blue {
    background-color: #1045e6;
    color: white;
}
</style>
